export const INITIATIVE_ACTIONS_HELPFILE =
  'https://www.questionpro.com/help/workforce/Create-Initiatives.html'
export const TASK_ACTIONS_HELPFILE =
  'https://www.questionpro.com/help/workforce/Tasks-Initiative.html'
export const UPSTREAM_DOWNSTREAM_HELPFILE =
  'https://www.questionpro.com/help/workforce/upstream-and-downstream.html'
export const CONVERSATIONS_HELPFILE =
  'https://www.questionpro.com/help/workforce/empower-conversations.html'
